<template>
  <hm-content title="广告列表" class="micro-goods-list">
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addAd"
          >添加广告</el-button
        >
        <el-button type="primary" size="small" @click="configAd"
          >广告配置</el-button
        >
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-select
          size="small"
          clearable
          placeholder="生效状态"
          v-model="searchCondition.enabledStateDesc"
          filterable
          class="mr10"
        >
          <el-option label="生效中" value="running"></el-option>
          <el-option label="待生效" value="notStart"></el-option>
          <el-option label="已失效" value="end"></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="开启状态"
          v-model="searchCondition.enabledState"
          filterable
          class="mr10"
        >
          <el-option label="开启" value="yes"></el-option>
          <el-option label="关闭" value="no"></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr10"
          clearable
          placeholder="广告模板筛选"
          v-model="searchCondition.templateType"
          filterable
        >
          <el-option
            v-for="(v, i) in adTempList"
            :key="i"
            :label="v.itemText"
            :value="v.itemValue"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="searchCondition.adName"
          placeholder="输入广告名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        @sort-change="sortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        stripe
        border
        ref="brandTable"
        :data="adList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="adName"
          label="广告名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="seqNum"
          sortable
          label="排序"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateTypeFormat"
          label="广告模板"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="广告图片">
          <template slot-scope="scope">
            <img :src="scope.row.adImg" alt="广告图片" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="adDescription"
          label="广告描述"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          sortable
          width="180px"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="showStartTime"
          sortable
          width="280px"
          label="生效时间"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.showStartTime }}至{{ scope.row.showEndTime }}</span
            >
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="链接类型">
          <template slot-scope="scope">
            <span>{{ scope.row.linkType === "goods" ? "商品" : "页面" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledStateDesc"
          label="生效状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.enabledStateDesc === 'end'">已失效</span>
            <span class="status success" v-show="scope.row.enabledStateDesc === 'running'">生效中</span>
            <span class="status blue" v-show="scope.row.enabledStateDesc === 'notStart'" >待生效</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="buttonClosePosition"
          label="关闭按钮位置"
        >
          <template slot-scope="scope">
            <span>{{scope.row.buttonClosePosition=='rightUpper'?'右上':scope.row.buttonClosePosition=='middleUpper'?'中上':scope.row.buttonClosePosition=='leftUpper'?'左上':scope.row.buttonClosePosition=='middleLower'?'中下':''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="开启状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.enabledState === 'no'"
              >关闭</span
            >
            <span
              class="status success"
              v-show="scope.row.enabledState === 'yes'"
              >开启</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div class="pointer mr10" @click="deleteAd(scope.row)">
                  <span class="hmicon icon-shanchu danger"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="adListTotal"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
      <el-dialog
        title='广告配置'
        :visible.sync='configVisible'
        width='693px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
        <!-- <div class='remarks-info'>这里显示备注的信息，这里显示备注的信息</div> -->
        <el-form label-width="80px" :model="configForm" ref='configForm' size="small">
          <el-form-item label="弹窗频率" required>
            <el-switch
              v-model="configForm.frequencyOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
            <div>{{!configForm.frequencyOpen? '广告弹窗只弹一次': '广告弹窗弹两次及以上'}}</div>
          </el-form-item>
          <el-form-item label="弹窗效果" required>
            <el-switch
              v-model="configForm.effectOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
            <div>{{!configForm.effectOpen? '关闭则多张弹窗背景，随机展示一张': '开启则多张弹窗背景同时轮播展示'}}</div>
          </el-form-item>
          
          <el-form-item label="">
            <img style="width: 156px;" v-if="configForm.effectOpen" src="https://imgcdn.hemiao100.com/static/lunbo.png" alt="">
            <img style="width: 156px;" v-else src="https://imgcdn.hemiao100.com/static/dange.png" alt="">
          </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleConfig' type='primary' size='small'>确定</el-button>
          <el-button @click='configVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      sort: { prop: "createTime", order: "descending" },
      adTempList: [],
      adList: [],
      adListTotal: 0,
      searchCondition: {},
      currentPage: 1,
      pageSize: 10,
      configVisible: false,
      configForm: {
        frequencyOpen: false,
        effectOpen: false,
      }
    };
  },
  created() {
    this.queryAdTempList();
  },
  activated() {
    this.queryList();
  },
  mounted() {},
  watch: {},
  methods: {
    async queryAdTempList() {
      const { result } = await this.$store.dispatch("queryAdTempList");
      this.adTempList = result;
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    /**
     * @desc 广告配置
    */
    configAd() {
      this.$store
      .dispatch("getModelByParamCode", {
        paramCode: "add_config_info",
      })
      .then((res) => {
        console.log("---res---", res);
        this.detailInfo = res.result;
        if (!res.result) {
          this.configForm.frequencyOpen = false;
          this.configForm.effectOpen = false;
        } else {
          this.configForm = JSON.parse(res.result.optionValues)
        }
        this.configVisible = true;
      });
    },
    handleConfig() {
      if (!this.detailInfo) {
        // 新增
        this.$store
          .dispatch("addStoreSystemParamInfo", {
            paramCode: "add_config_info",
            paramValue: true,
            optionValues: JSON.stringify(this.configForm),
            configType: "store",
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      } else {
        this.$store
          .dispatch("editStoreSystemParamInfo", {
            paramCode: "add_config_info",
            paramValue: true,
            optionValues: JSON.stringify(this.configForm),
            id: this.detailInfo.id,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      }
    },
    addAd() {
      this.$router.push({ name: "AddAd" });
    },
    deleteAd(row) {
      this.$confirm(`确认删除广告“${row.adName || row.adId}”吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteAd", { adId: row.adId })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    edit(row) {
      this.$store.commit("QUERY_AD_DETAILS", row);
      this.$router.push({
        name: "EditAd",
        query: {
          adId: row.adId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          wxshopSpuIdList: row.wxshopSpuId
        };
        if (type) {
          actionName = "batchEditMicroShopGoods";
          params = {
            wxshopSpuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryAdList", params);
      const { records, total } = result;
      records.forEach(v => {
        this.adTempList.map(o => {
          if (v.templateType === o.itemValue) {
            v.templateTypeFormat = o.itemText;
          }
        });
      });
      this.adList = records;
      this.adListTotal = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
</style>
<style scoped lang="scss">
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.table {
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}
</style>
